export default [
  {
    code: 1,
    message: "Invalid credentials"
  },
  {
    code: 2,
    message: "User not found"
  },
  {
    code: 3,
    message: "User already activated"
  },
  {
    code: 4,
    message: "User not enabled at this company"
  },
  {
    code: 12,
    message: "User blocked at this company"
  }
]



// WEBPACK FOOTER //
// ./src/helpers/accountActivateErrors.js